import axios from 'axios';

const api = axios.create({
  baseURL: 'https://api.cofres.intelmaxsolucoes.com.br',
  // baseURL: 'http://localhost:3334',
});

export default api;
